import { logger } from '@belong/logging/logger';
import ContentAPI from 'src/services/ContentAPI';
import SiteConfig from 'src/models/SiteConfig';

// Server Side Rendering: Load fresh data
const load = async (correlationId?: string): Promise<any> => {
  logger.debug(correlationId, 'GlobalConfig::load');
  const config = await ContentAPI.getConfig();

  return { ...config[0].fields };
};

/**
 * Responsible for fetching global data:
 * - Support Categories
 * - Shared Sections
 * - 'alert' for displaying on /support/:category and /support/:category/:article
 */
export const getGlobalConfig = async (correlationId?: string): Promise<SiteConfig> => {
  const instance = new SiteConfig();
  const data = await load(correlationId);
  await instance.init(data);

  return instance;
};
